export const environment = {
  production: false,
  uri: 'https://dsistemasweb.sefaz.ba.gov.br/sistemas/gpa/api',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts